// Refresh3DContext.js
"use client";
import { createContext, useContext, useState } from "react";

const Refresh3DContext = createContext();

export function Refresh3DProvider({ children }) {
  const [refreshState, setRefreshState] = useState(0);

  const refresh = () => {
    setRefreshState((prev) => prev + 1);
  };

  return (
    <Refresh3DContext.Provider value={{ refresh, refreshState }}>
      {children}
    </Refresh3DContext.Provider>
  );
}

export function useRefresh3D() {
  const context = useContext(Refresh3DContext);
  if (!context) {
    throw new Error("useRefresh3D must be used within a Refresh3DProvider");
  }
  return context;
}